import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesProductUsageGuides } from "../../constants";

export const requestDeleteUsageGuide = async (id: string): Promise<void> => {
  // Takes the guide's FAQ items with it. For a category guide it also removes
  // the section from every product that was inheriting it.
  return await instance.delete(
    buildUrl(ApiRoutesProductUsageGuides.Guides, id)
  );
};
